import React from "react";
import Skeleton from "../loader/Skeleton";
import { Link } from "react-router-dom";

const StatdataItem = ({ data, loading }) => {
  return (
    <div className="group relative h-full">
      <Link
        key={data.id}
        to={data?.link}
        className={`group relative shadow rounded-lg cursor-pointer transition-all duration-300 hover:shadow-xl hover:shadow-primary/10 border border-transparent hover:border-primary/10 hover:no-underline flex flex-col px-5 py-5 h-full`}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex-shrink-0 flex items-center justify-center w-12 md:w-16 aspect-square rounded-lg bg-primary/10 text-primary text-3xl">
            {data?.icon && <i className={`${data.icon}`} />}
            {data?.iconStr}
          </div>
          {data.id === "net-sales" && (
            <div className="text-primary transition-colors cursor-pointer">
              <i className="fa-light fa-info-circle "></i>
            </div>
          )}
        </div>

        <div className="text-sm font-medium text-primary mb-2">
          {data.title}
        </div>
        {loading ? (
          <Skeleton />
        ) : (
          <div className="flex items-baseline gap-2 mb-2">
            <span className="text-2xl font-bold text-deep-purple">
              {data.value || 0}
            </span>
            {data.subValue >= 0 && (
              <span className="text-lg text-deep-purple">
                {"/" + data.subValue}
              </span>
            )}
          </div>
        )}

        {data.footerText && (
          <div className="text-sm text-primary">{data.footerText}</div>
        )}

        <div className="mt-auto pt-4 flex">
          {data.showButton && (
            <button className="text-deep-purple text-sm font-medium">
              {data.description}
            </button>
          )}
        </div>
      </Link>
    </div>
  );
};

export default StatdataItem;
